import React, { useEffect, useMemo, useState } from "react";
import useInventoryApi from "./useInventoryApi";
import "./Inventory.css";

export default function VendorsPage() {
  const { listVendors } = useInventoryApi();
  const [vendors, setVendors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState("");

  useEffect(() => {
    let live = true;
    setLoading(true);
    listVendors()
      .then((r) => { if (live) setVendors(Array.isArray(r) ? r : r?.results || []); })
      .finally(() => { if (live) setLoading(false); });
    return () => { live = false; };
  }, [listVendors]);

  const filtered = useMemo(
    () => vendors.filter((v) => !q || `${v.name} ${v.email || ""} ${v.contact || ""}`.toLowerCase().includes(q.toLowerCase())),
    [vendors, q]
  );

  return (
    <div className="inventory-page">
      <header className="inventory-head">
        <div>
          <h1>Vendors</h1>
          <p className="muted">Suppliers and procurement terms.</p>
        </div>
        <div className="filters">
          <input placeholder="Search vendors…" value={q} onChange={(e) => setQ(e.target.value)} />
        </div>
      </header>

      <section className="inventory-grid">
        <div className="inventory-stat">
          <div className="label">Vendors</div>
          <div className="value">{vendors.length}</div>
        </div>
        <div className="inventory-stat">
          <div className="label">With Terms</div>
          <div className="value">{vendors.filter((v) => v.terms).length}</div>
        </div>
      </section>

      <section className="inventory-card">
        <div className="inventory-table" style={{ "--inventory-columns": "1.3fr 1.1fr 1.4fr 1fr 0.8fr" }}>
          <div className="inventory-thead">
            <div>Vendor</div>
            <div>Contact</div>
            <div>Email</div>
            <div>Phone</div>
            <div>Terms</div>
          </div>
          {loading ? (
            <div className="inventory-row muted">Loading…</div>
          ) : filtered.length === 0 ? (
            <div className="inventory-empty">
              <div className="value" style={{ fontSize: 15 }}>No vendors yet</div>
              <p className="muted" style={{ margin: "6px 0 0" }}>
                Vendors are created from products or receipt imports; they appear here.
              </p>
            </div>
          ) : (
            filtered.map((v) => (
              <div key={v.id} className="inventory-row">
                <div>{v.name}</div>
                <div>{v.contact || "—"}</div>
                <div>{v.email || "—"}</div>
                <div>{v.phone || "—"}</div>
                <div>{v.terms ? <span className="inventory-pill">{v.terms}</span> : "—"}</div>
              </div>
            ))
          )}
        </div>
      </section>
    </div>
  );
}
